import { createSelector } from 'reselect';

const getFlightOfferState = (state) => state.flightOffers || [];

export const getFlightOffers = createSelector([getFlightOfferState], (s) => {
  return (s.offers || []).map((offer) => {
    return {
      key: offer.node?.offers?.map((o) => o.tripId).join('|'),
      node: {
        country: offer.node?.hotel?.content?.geographical?.country,
        ...offer.node,
      },
    };
  });
});

export const getLastCursor = createSelector([getFlightOfferState], (s) => {
  const offers = s.offers || [];

  if (offers.length) {
    return offers[offers.length - 1].cursor;
  }

  return null;
});
